import React from 'react';
import './style.css';
import { Avatar } from '@mui/material';
import { chracterPosition } from '../../../../utils/index';
import { colorCodesForAvatar } from '../../../../constants/index';

function GroupTicket({ groups = [], onChangeGroup, headerTitle = "Group", compact = false }) {
  const getAvatarColor = (name) => {
    if (!name) return colorCodesForAvatar[0];
    const first = name[0].toUpperCase();
    const idx = first.charCodeAt(0) - 65;
    return colorCodesForAvatar[(idx >= 0 && idx < colorCodesForAvatar.length) ? idx : 0];
  };
  return (
    <div
      style={{ marginTop: compact ? 0 : "8px", minHeight: compact ? "auto" : "128px" }}
      className="SuperVisor-Main-Container"
    >
      <div className="SuperVisor-Header-text">
        <p className="SuperVisorText">{headerTitle}</p>
        <p className="SuperVisorChange" onClick={onChangeGroup} style={{ cursor: 'pointer' }}>{groups.length === 0 ? 'Add Group' : 'Change'}</p>
      </div>
      {Array.isArray(groups) && groups.length > 0 ? (
        groups.map((group) => (
          <div className="SuperVisor-Logo-container" key={group._id}>
            {group.group_image ? (
              <Avatar
                src={group.group_image}
                sx={{
                  width: compact ? 32 : 40,
                  height: compact ? 32 : 40,
                  mr: 1,
                  fontSize: compact ? "13px" : "16px",
                  fontWeight: "500",
                }}
              />
            ) : (
              <Avatar
                sx={{
                  width: compact ? 32 : 40,
                  height: compact ? 32 : 40,
                  mr: 1,
                  fontSize: compact ? "13px" : "16px",
                  fontWeight: "500",
                  bgcolor: getAvatarColor(group.title),
                  color: "#fff",
                }}
              >
                {group.title?.charAt(0)?.toUpperCase()}
              </Avatar>
            )}
            <div className="Super-Main-text">
              <p style={{ textTransform: 'capitalize' }} className="Super-Robert-text">{group.title}</p>
              <p className="Super-Kenzi-text">
                {typeof group.total_agents === "number"
                  ? `${group.total_agents} member${group.total_agents !== 1 ? "s" : ""}`
                  : typeof group.agents === "number"
                    ? `${group.agents} member${group.agents !== 1 ? "s" : ""}`
                    : Array.isArray(group.agents)
                      ? `${group.agents.length} member${group.agents.length !== 1 ? "s" : ""}`
                      : "0 members"}
              </p>
            </div>
          </div>
        ))
      ) : (
        <div
          className='NoGroupSelectedMessage'
        >
          No Group Selected
        </div>

      )}
    </div>
  );
}

export default GroupTicket;
